(function ($, Drupal, once) {
  Drupal.behaviors.support_ga_events = {
    attach: function attach(context) {
      // Generic click tracking
      $(once('ga-event', '[data-ga-track-click]', context)).click(function (e) {
        const $element = $(e.target);
        const gaLabel = $element.attr('data-ga-event-label');

        if (typeof gtag !== 'undefined' && gaLabel) {
          gtag('event', gaLabel, {
            label: gaLabel,
          });
        }
      });

      // Track General "Live Chat" link.
      $(once('click-general-live-chat', '.js-button-live-chat', context)).on(
        'click',
        function () {
          if (typeof gtag !== 'undefined') {
            gtag('event', 'click_live_chat_general_link', {
              label: 'LC_GENERAL',
            });
          }
        },
      );

      // Billing payment confirmation modal
      $(once('ga-events', 'html'))
        .on('dialog:aftercreate', function () {
          $('form.veolia-billing-payment.confirmation').each(function () {
            const $paymentForm = $(this);
            const $paymentDialog = $paymentForm.parents('.ui-dialog').eq(0);
            const $continueButton = $paymentDialog.find(
              'button.button--primary',
            );
            $continueButton.click(function () {
              const gaLabel = 'Billing_Pay_Confirm';
              if (typeof gtag !== 'undefined' && gaLabel) {
                gtag('event', gaLabel, {
                  label: gaLabel,
                });
              }
            });
          });
        });
      // Track "Send Message" and other webform buttons
      $(once('webform-ga-event', '.webform-submission-form .btn-submit[data-ga-event-label]', context))
        .click(function (e) {
          const element = e.target;
          const $element = $(element);
          const gaLabel = $element.data('ga-event-label');

          if (typeof gtag !== 'undefined' && gaLabel) {
            // Send event to GA, wait, continue.
            e.stopImmediatePropagation();
            gtag('event', gaLabel, {
              label: gaLabel,
              event_callback() {
                // Look for an AJAX handler, if found, invoke it.
                let fired = false;
                if (typeof Drupal.ajax.instances === 'object') {
                  $.each(Drupal.ajax.instances, function (index, instance) {
                    if (instance && instance.element === element) {
                      instance.eventResponse(element, e);
                      fired = true;
                    }
                  });
                }
                // No AJAX handler, just submit normally.
                if (!fired) {
                  $element.closest('form').submit();
                }
              },
            });
          }
        });

      // Support page (FAQs)
      $(once('expandable-block-title', '.expandable-block-title', context)).each(function () {
        const $expandableBlockTitle = $(this);
        const $expandableBlockContainer = $expandableBlockTitle.parent();

        // Track expandables reveal
        $expandableBlockTitle.on('expandable_revealed', function (e) {
          const $blockTitle = $(e.target);
          if (typeof gtag !== 'undefined') {
            gtag('event', 'expandable_reveal', {
              label: $blockTitle.attr('data-ga-event-label'),
            });
          }
        });

        // Track expandables collapsed
        $expandableBlockTitle.on('expandable_collapsed', function (e) {
          const $blockTitle = $(e.target);
          if (typeof gtag !== 'undefined') {
            gtag('event', 'expandable_collapse', {
              label: $blockTitle.attr('data-ga-event-label'),
            });
          }
        });

        // No further processing for outer containers.
        if ($expandableBlockContainer.find('.expandable-block-container').length > 0) {
          return;
        }

        // Track Links inside description
        $expandableBlockContainer.find('.field--name-field-description a').click(function (e) {
          const $link = $(e.target);
          const $linkLabel = $link.text().replace(/\s+/g, '_');
          const parentExpandableGAEventLabel = $expandableBlockContainer
            .find('.faq-item-title')
            .data('ga-link-event-label');
          if (typeof gtag !== 'undefined') {
            gtag('event', 'click_description_link', {
              label: `L_${$linkLabel}_${parentExpandableGAEventLabel}`,
            });
          }
        });

        // Track "Send Us a Message" links on each sub category
        // IMPORTANT: The event "click_send_us_message_link" has to be marked as
        // key event in GA to be submitted immediately. Otherwise, when it
        // is a link it navigates away from the current url before the event
        // is tracked (because events push are delayed 5 seconds by GA).
        $expandableBlockContainer
          .find('[data-ga-event-type=SM]')
          .click(function (e) {
            const $element = $(e.target);
            const $linkLabel = $element.data('ga-event-label');
            const targetUrl = $element.attr('href'); // Only relevant for <a> tags

            if (typeof gtag !== 'undefined') {
              gtag('event', 'click_send_us_message_link', {
                label: $linkLabel,
                event_callback() {
                  // Redirect only if it's an <a> tag (not <button>)
                  if ($element.is('a') && targetUrl) {
                    window.location.href = targetUrl;
                  }
                },
              });
            }

            // If the element is an <a> tag, prevent default navigation to allow tracking
            if ($element.is('a')) {
              e.preventDefault();
            }
          });

        // Track "Live Chat" links on each sub category
        $expandableBlockContainer
          .find('button[data-type=live-chat]')
          .click(function (e) {
            const $button = $(e.target);
            const $buttonLabel = $button.data('ga-event-label');
            if (typeof gtag !== 'undefined') {
              gtag('event', 'click_live_chat_subcategory_link', {
                label: $buttonLabel,
              });
            }
          });
      });
    },
  };
}(jQuery, Drupal, once));
